<template>
  <div>
    <div>{{ item.company }}</div>
    <div>{{ item.VAT }}</div>
    <div>{{ item.id }}</div>
  </div>
</template>

<script>
export default {
  name: "ClientAutocompleteItem",
  props: {
    item: { required: true },
  }
};
</script>

<style scoped></style>
